var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGosite = function SvgGosite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.64684 9.48434L6.62537 3.50165L12.6081 9.48434C13.7863 7.0199 13.3549 3.98292 11.3136 1.94168C8.72471 -0.647225 4.53019 -0.647225 1.94129 1.94168C-0.099958 3.98292 -0.531441 7.0199 0.64684 9.48434Z",
    fill: "#0058FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62526 3.50195L0.646729 9.48464C0.962043 10.1443 1.39353 10.7666 1.94118 11.3143L3.11116 12.4884L6.62526 8.97433L10.1394 12.4884L11.3093 11.3184C11.857 10.7708 12.2885 10.1526 12.6038 9.48879L6.62526 3.50195Z",
    fill: "#08B2FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62416 8.97179L3.10962 12.4863L6.62416 16.0009L10.1387 12.4863L6.62416 8.97179Z",
    fill: "#86EAFA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGosite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gosite.00d73c33.svg";
export { ForwardRef as ReactComponent };